module.exports = __webpack_public_path__ + "static/media/fvs_fremdlinge_23.701b97d7.jpg";